import { render, staticRenderFns } from "./ErrorSection.vue?vue&type=template&id=06bc7bd2&"
import script from "./ErrorSection.vue?vue&type=script&lang=js&"
export * from "./ErrorSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports